import { FilterPipe } from './filter/filter';
import { NgModule } from '@angular/core';
import { ReversePipe } from './reverse/reverse';
import { OrderByPipe } from './order-by/order-by';
import { LinkifyPipe } from './linkify/linkify';
import { CallbackPipe } from './callback/callback';


@NgModule({
  declarations: [
    FilterPipe,
    ReversePipe,
    OrderByPipe,
    LinkifyPipe,
    CallbackPipe
  ],
  imports:[

  ],
  exports:[
    FilterPipe,
    ReversePipe,
    OrderByPipe,
    LinkifyPipe,
    CallbackPipe
  ]
})
export class PipeModules{}



// WEBPACK FOOTER //
// ./src/pipes/pipes.modules.ts